/**
 * Cognito config read from Vite env vars at module load.
 *
 * In CI these come from the workflow's deploy-web step, which exports the
 * Terraform outputs from envs/staging. In local dev they come from
 * apps/web/.env.local — copy .env.example and fill in the values.
 *
 * Missing vars throw immediately rather than failing later in an opaque
 * Cognito call. The error message points at the fix.
 */

function readVar(name: string): string {
  const value = import.meta.env[name] as string | undefined;
  if (!value) {
    throw new Error(
      `Missing required env var: ${name}. ` +
        `Copy apps/web/.env.example to apps/web/.env.local and fill in the values from staging Cognito.`,
    );
  }
  return value;
}

export const authConfig = {
  userPoolId: readVar('VITE_COGNITO_USER_POOL_ID'),
  userPoolClientId: readVar('VITE_COGNITO_USER_POOL_CLIENT_ID'),
  region: (import.meta.env.VITE_AWS_REGION as string | undefined) ?? 'eu-west-1',
};
